<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" ref="field"
             :label="label">
        <q-input-frame :error="hasError"
                       :disable="disable"
                       :hide-underline="hideUnderline"
                       :before="before"
                       :after="lendingKitIcon()"
                       :dusk="path"
                       :color="color"
                       class="q-input"
                       :class="{original: original}">
            <slot><span v-html="displayValue" :class="{ ellipsis: type != 'textarea' }"></span></slot>
        </q-input-frame>
        <q-modal v-model="showModal" :content-css="{minWidth: '50vw', minHeight: '50vh'}">
            <q-modal-layout>
                <div>
                    <v-header
                            :title="$T('change kit')"
                            icon="edit">
                    </v-header>
                    <card width="100%" style="width: 40vw!important;">

                        <form class="row gutter-xs">
                            <div class=" col-12">
                                <v-display v-model="formEdit.old_kit"
                                           :label="$t('old Lending kit')"
                                           :options="options"
                                           :form="formEdit"
                                           class="row col-md-4 col-sm-6 col-xs-12">
                                </v-display>
                            </div>
                            <div class=" col-12">
                                <v-autocomplete path="lending_point_id"
                                                resource-path="v1/lending-points"
                                                key="lending_point_id"
                                                v-model="formEdit.lending_point_id"
                                                :label="$t('lending point')"
                                                :item-plural="$t('lending points')"
                                                :map="item => ({
                                                label: item.description,
                                                value: item.id
                                            })"
                                                :form="formEdit"
                                                class="row col-xl-3 col-md-4 col-sm-6 col-xs-12">
                                </v-autocomplete>
                            </div>
                            <div class=" col-12">

                                <v-select path="kit_status"
                                          auto-select
                                          v-model="formEdit.kit_status"
                                          :label="$t('new status for old kit')"
                                          :options="lendingKitStatuses"
                                          :form="formEdit"
                                          class="row col-md-4 col-sm-6 col-xs-12">
                                </v-select>
                            </div>
                            <div class=" col-12">

                                <v-autocomplete path="lending_kit_id"
                                                resource-path="v1/available-lending-kits"
                                                key="lending_kit_id"
                                                v-model="formEdit.lending_kit_id"
                                                :label="$t('lending kit')"
                                                :item-plural="$t('lending kits')"
                                                :map="item => ({
                                        label: `${this.$T('identifier')}: ${item.identifier}`,
                                        value: item.id,
                                        sublabel: `${this.$T('codentify')}: ${item.codentify}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
                                    })"
                                                :form="formEdit"
                                                class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                                </v-autocomplete>
                            </div>
                            <div class=" col-12">
                                <v-input path="justify"
                                         v-model="formEdit.justify"
                                         :label="$t('justify')"
                                         :form="formEdit"
                                         type="textarea"
                                         class="col-md-4 col-sm-6 col-xs-12">
                                </v-input>
                            </div>
                        </form>

                    </card>
                </div>
                <q-toolbar color="white" slot="footer">
                    <div class="row">
                        <div class="col q-gutter-md" slot="footer">
                            <v-button :label="$t('cancel')" outline size="md" v-close-overlay/>
                            <v-button :label="$t('save')" outline size="md" @click="save"/>

                        </div>
                    </div>
                </q-toolbar>

            </q-modal-layout>
        </q-modal>
    </v-field>
</template>

<script>
import mixins from './form/mixins'
import moment from 'moment'
import {
    date,
    QInputFrame
} from 'quasar-framework'
import VSelect from './form/VSelect'
import Form from 'vform'
import VDisplay from './form/VDisplay'
import VInput from './form/VInput'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'LendingKitEdit',
    components: {VDisplay, VSelect, QInputFrame, VInput},
    mixins,
    data () {
        return {
            showModal: false,
            formEdit: new Form({
                lending_point_id: null,
                old_kit: this.value,
                kit_status: null,
                lending_kit_id: null,
                justify: ''
            }),
            lendingPoints: [],
            lendingKitStatuses: [],
            lendingKits: []
        }
    },
    props: {
        innerLabel: String,
        negativeLabel: String,
        options: {
            type: Array,
            default () {
                return []
            }
        },
        type: String,
        format: {
            type: String
        },
        hideUnderline: Boolean,
        original: Boolean
    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
        displayValue () {
            if (this.options.length > 0) {
                var result = this.options.filter(option => option.value == this.value)
                if (result.length === 0) return
                return result[0].label
            }
            if (this.value === null || typeof (this.value) === "undefined")
                return this.$t('not_available')
            if (this.format || moment(this.value, 'DD/MM/YYYY HH:mm', true).isValid())
                return moment(this.value, 'DD/MM/YYYY HH:mm').format(this.format || this.defaultDateTimeFormat)
            if (this.format || moment(this.value, 'DD/MM/YYYY', true).isValid())
                return moment(this.value, 'DD/MM/YYYY').format(this.format || this.defaultDateFormat)
            if ((this.value === true || this.value === false) || this.negativeLabel)
                return !!this.value ? this.innerLabel : this.negativeLabel
            if (typeof this.value === 'string')
                return this.value.replace(/(?:\r\n|\r|\n)/g, '<br />')
            return this.value
        },

        defaultDateFormat () {
            return this.$t('date_format')
        },

        defaultDateTimeFormat () {
            return this.$t('datetime_format')
        },
        isBackOffice () {
            return this.user && this.user.role.name === 'Backoffice'
        }
    },

    async mounted () {
        this.$refs.field.$refs.QField.__registerInput({$options: {}})
        await axios.get('/api/v1/stock-statuses')
            .then(response => {
                this.lendingKitStatuses = response.data.data
            })
        await axios.get('/api/lending-kit/' + this.value)
            .then(response => {
                this.oldKit = response.data.model
            })
    },
    methods: {
        lendingKitIcon () {
            if (this.user && !this.user.can_change_kits_in_lending) return []
            return [
                {
                    icon: 'edit',
                    handler: () => {
                        this.showModal = true
                    }
                }
            ]
        },
        save () {
            this.formEdit.orderId = this.$route.params.id
            this.formEdit.post('/api/v1/update-kit-order')
                .then(response => {
                    if (response.data.hasOwnProperty('success')) {
                        this.$q.notify({
                            color: 'positive',
                            icon: 'thumb_up',
                            message: response.data.success.message
                        })
                        setTimeout(() => { window.location.reload() }, 1000);
                    } else if (response.data.hasOwnProperty('errors')) {
                        Object.values(response.data.errors).forEach((error) => {
                            this.$q.notify({
                                color: 'warning',
                                icon: 'warning',
                                message: error[0]
                            })
                        })
                    }
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LendingKitEdit.vue